export const Authorization = () => {
  const authData = localStorage.getItem("authData");

  if (authData) {
    const parsedData = JSON.parse(authData);
    const token = parsedData.token; // Assuming the token is stored in 'userToken'
    // const permissionToken = parsedData.token; // You can use this if needed

    return {
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        // "X-Permission-Token": permissionToken, // Add this if you need it
      },
    };
  }

  return {};
};
